'use client';
import { Tabs } from '@/components/home/Tabs';
import headerTabs from '@/components/home/headerTabs';
import { TabWithSideImageContent } from '@/components/home/TabWithSideImageContent';
import headerImage from './assets/hero.webp';
import Image from 'next/image';
import Button from '@/components/common/Button';
import Chevron from '../../../public/assets/icons/chevron-right.svg';
import sidePanelBg from './assets/sidePanelBg.png';
import SidePanelIcon from './assets/sidePanelIcon.svg';
import HeroCarousel from './HeroCarousel';

// Toggle the hero between the animated carousel and the original static layout.
// Set to `false` to fully revert to the pre-carousel hero — nothing else changes.
const USE_HERO_CAROUSEL = true;

const StaticHero = () => (
  <section className="w-full">
    <div className="relative overflow-hidden">
      <div className="-z-10">
        <Image
          src={headerImage}
          alt="man working on laptop"
          quality={100}
          fill
          className="object-cover"
          loading="eager"
          sizes="(min-width: 1780px) 1584px, (min-width: 1440px) calc(45vw + 792px), 1344px"
          unoptimized
        />
        <div className="home-header-gradient" />
        <div className="home-header-bottom-gradient" />
      </div>
      <div className="relative flex min-h-[43.75rem] flex-col px-4 pt-25 sm:px-10">
        <p className="square-subtitle mb-4 text-white">
          Your Data. Your Rules.
        </p>
        <h1 className="text-h4 sm:text-h3 lg:text-h2 font-light text-white mb-[20px]">
          Control what your people{' '}
          <br className="hidden lg:inline" /> and AI agents can see,
          <br className="hidden lg:inline" /> decide, and do.
        </h1>
        <p className="text-lg sm:text-xl lg:text-h6 mt-1 max-w-xl text-white font-[400]">
          Zero Trust policy, unified identity, and total visibility, in one
          platform.
        </p>
        <Button
          href="/contact"
          className="mt-8 w-72 max-w-full justify-center font-bold !bg-white !text-primary-10 hover:!bg-white/90"
        >
          Let&apos;s Talk
          <span className="pl-2">
            <Chevron />
          </span>
        </Button>
      </div>
    </div>
  </section>
);

const HomeHeader = () => {
  return (
    <>
      {USE_HERO_CAROUSEL ? <HeroCarousel /> : <StaticHero />}
      <section className="-mt-[8.5rem] mb-10 w-full px-4 sm:px-10 lg:h-[500px]">
        <div className="isolate h-full overflow-hidden shadow lg:flex">
            <div
              className="flex w-full shrink-0 flex-col justify-center gap-4 bg-[#333333] bg-cover bg-center px-10 py-12 text-white lg:w-80"
              style={{ backgroundImage: `url(${sidePanelBg.src})` }}
            >
              <SidePanelIcon className="mb-2 h-auto w-[87px]" />
              <h2 className="text-h5">Built-in security control from identity to access</h2>
              <p className="font-light text-white text-[14px]">Policy, identity, access, and AI governance, designed to work as one.</p>
            </div>
          <Tabs
            dataset={headerTabs}
            type="card"
            render={(tabData) => (
              <TabWithSideImageContent
                heading={tabData.heading}
                description={tabData?.description}
                bullets={tabData.bullets}
                Diagram={tabData.Diagram}
                key={tabData.heading}
                bgDecoration={tabData.bgDecoration}
              />
            )}
          />
        </div>
      </section>
    </>
  );
};

export default HomeHeader;
